exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".input-group[data-v-1afffc7a]{margin-bottom:20px;display:block;margin:0 auto;width:100%;margin-bottom:2rem!important}.input-group .input-field[data-v-1afffc7a]{padding-left:50px;max-width:100%!important;border-width:1px;margin-bottom:0!important}.input-group span.span-awesome[data-v-1afffc7a]{font-size:16px;position:absolute;top:15px;left:20px;color:#6d6e71}@media (min-width:1200px){.input-group[data-v-1afffc7a]{max-width:410px!important}.input-group .input-field[data-v-1afffc7a]{padding-left:50px}.input-group span.span-awesome[data-v-1afffc7a]{left:20px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1afffc7a","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/views/homepage/TeacherLanding.vue
// module id = 307
// module chunks = 0